$(document).ready(function () {
    $("li:first-child").addClass("first");
    $("li:last-child").addClass("last");
    $(".menu .menu-item-has-children").addClass("dropdown-nav ");
    $(".menu .menu-item-has-children ul.sub-menu").addClass("dropdown");
    $('[href="#"],[href=""]').attr("href", "javascript:;");

    // Mobile Menu
    var len = $('.menu > li'), str;
    $(".menu-Bar").click(function () {
        $(this).toggleClass("open");
        $(".menuWrap").toggleClass("open");
        $("body").toggleClass("ovr-hiddn");
        for (var i = 1; i < len.length; i++) {
            str = (300 + 100 * (i - 1)) + "ms";
            len.eq(i).css('animation-delay', str)
        }
    });
    $('.dropdown-nav').prepend('<span class="toggle_submenu"><i class="fal fa-plus"></i></span>')
    $('.toggle_submenu').click(function () {
        $('ul.dropdown').slideUp();
        $('.toggle_submenu').removeClass('active')
        if ($(this).parent().find('ul.dropdown').is(':visible')) {
            $(this).removeClass('active')
            $(this).parent().find('ul.dropdown').slideUp();
        } else {
            $(this).addClass('active')
            $(this).parent().find('ul.dropdown').slideDown()
        }
    })


    $('.menu li a').click(function() {
        $(this).closest("li").find("[class^='inner-dropdowns']").slideToggle();
        $(this).find(".rotate").toggleClass("down");
    });


    $('.moreless-button').click(function() {
    
        $('.moretext').slideToggle('slow');
    
        if ($('.moreless-button').text() == "View More") {
    
            $(this).text("View less")
        } else {
            $(this).text("View More")
    
        }
    });
  

    // SearchBar
    $('.search_btn').click(function () {
        $('.backdrop').fadeIn()
        $('.search_bar').addClass('active')
    })
    $('.hideSerch,.backdrop').click(function () {
        $('.search_bar').removeClass('active')
        $('.backdrop').fadeOut()
    })

    // Tabbing Function
    $("[data-targetit]").on("click", function (e) {
        $(this).addClass("active");
        $(this).siblings().removeClass("active");
        var target = $(this).data("targetit");
        var tablen = $("." + target).find('.tab-content .row > div'), tebstr;
        $("." + target).siblings('[class^="box-"]').hide();
        $('.tab-content .row > div').addClass('animate__zoomIn');
        $("." + target).show().show().find('.tab-content .row > div').addClass('animate__zoomIn');
        for (var i = 1; i < tablen.length; i++) {
            tebstr = (100 + 100 * (i - 1)) + "ms";
            tablen.eq(i).css('animation-delay', tebstr)
        }
    });

    // Accordion
    $(".accordions .acc_title").click(function () {
        $('.accordions li').removeClass('active')
        $('.acc_desc').slideUp();
        $(this).parent('li').addClass('active')
        if (!$(this).next('.acc_desc').is(':visible')) {
            $(this).next('.acc_desc').slideDown();
        } else {
            $('.accordions li').removeClass('active')
        }
    });

    // Slick Slider
    $(".s3_slider").slick({
        dots: false,
        infinite: true,
        // speed: 0,
        fade: true,
        slidesToShow: 1,
        adaptiveHeight:true,
        prevArrow: $('.s3 .arr_l'),
        nextArrow: $('.s3 .arr_r')
    });

    //     Slider For
    // Counter
    var $slickElement = $('.s4_slider');
    var $sliderStart = $('.count_current');
    var $sliderEnd = $('.count_total');
    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        $sliderStart.text('0' + i);
        $sliderEnd.text('0' + slick.slideCount);
    });


    $slickElement.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
		speed: 1000,  
        asNavFor: '.s4_slider_nav',
        prevArrow: $('.slick_controls .arr_l'),
        nextArrow: $('.slick_controls .arr_r'),
		responsive: [
			{
				breakpoint: 768,
				settings: {
					adaptiveHeight:true
				}
			}
		]
    });

    $('.related_product_slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        fade: false,
      responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
				}
			},
        {
				breakpoint: 576,
				settings: {
					slidesToShow: 2,
				}
			}
		]
    });

  
    $('.product_slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        fade: true,
        adaptiveHeight:true
    });
  
    $('.s4_slider_nav').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        asNavFor: '.s4_slider',
        dots: false,
        arrows: false,
        focusOnSelect: true,

    });



    // Increament Qty
    $('.has_qty').each(function () {
        let qty = 1;
        $(this).find('.qty_count').on('change', function () {
            qty = $(this).val();
        })
        $(this).find('.num_dec').on('click', function () {
            qty > 1 && qty--;
            $(this).parent().find('.qty_count').val(qty);
        })
        $(this).find('.num_inc').on('click', function () {
            qty >= 1 && qty++;
            $(this).parent().find(".qty_count").val(qty);
        })
    })

    // Sticky Header
    // $(window).on("scroll touchmove", function () {
    //     $(".main-header").toggleClass("sticky", $(document).scrollTop() > 200);
    // });

    // Input label
    $('.input_group input,.input_group textarea').blur(function () {
        $(this).val() !== '' ? $(this).next('label').addClass('has_value') : $(this).next('label').removeClass('has_value')
    })

});



// Header Opacity
// var targetElement = $('.main-header'),
//     limit = 1000;  /* scrolltop value when opacity should be 0 */
// if ($(window).scrollTop() > $(window).height()) {
//     targetElement.css({
//         'background-color': 'rgb(0, 10, 60)'
//     });
// }
// $(window).on('scroll touchmove', function () {
//     var st = $(this).scrollTop();
//     if (st <= limit) {
//         targetElement.css({
//             'background-color': 'rgba(0, 15, 25, ' + (0 + st / limit) + ')'
//         });
//     }
// });

// Active Menu Class
$(window).on("load", function () {
    var currentUrl = window.location.href.substr(
        window.location.href.lastIndexOf("/") + 1
    );
    $("ul.menu li a").each(function () {
        var hrefVal = $(this).attr("href");
        if (hrefVal == currentUrl) {
            $('ul.menu li').removeClass("active");
            $(this).removeClass("active");
            $(this)
                .closest("li")
                .addClass("active");
        }
    });
    $('.dropdown-nav li').each(function () {
        if ($(this).hasClass('active')) {
            $(this).parent().parent().addClass('active')
        }
    })
});
